import { Subject } from 'rxjs';

export const backToMasterPage$ = new Subject<void>();

export function backToMaster() {
  backToMasterPage$.next();
}
